(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atlas-cursor-ring"] && !Shopify.designMode) return;
  try {
    /* ATLAS cursor enhancement. Keeps the native logo cursor; never hides the pointer. */
(() => {
  if (window.__atlasCursorRing) return;
  const controller = new AbortController();
  window.__atlasCursorRing = controller;
  const { signal } = controller;
  const media = matchMedia('(hover: hover) and (pointer: fine)');
  const ring = document.createElement('span');
  ring.id = 'atlas-cursor-ring';
  ring.setAttribute('aria-hidden', 'true');
  document.body.append(ring);
  document.documentElement.setAttribute('data-atlas-cursor-ring-ready', '');
  const actions = 'product-card,a[href],button,summary,[role="button"],[role="link"],select,' +
    'input[type="checkbox"],input[type="radio"],input[type="submit"],input[type="button"],' +
    '.account-button,.jdgm-preview-badge--with-link,.jdgm-histogram__row';
  const styledRoots = new WeakSet();
  function styleShadowAction(action) {
    const root = action?.getRootNode();
    if (!(root instanceof ShadowRoot) || styledRoots.has(root)) return;
    const style = document.createElement('style');
    style.textContent = 'a,button,[role="button"],summary,a *,button * { cursor: ' + getComputedStyle(document.documentElement).cursor + ' !important; }';
    root.append(style);
    styledRoots.add(root);
  }
  let frame = 0;
  let point = { x: -100, y: -100 };
  let active = false;
  const hide = () => { if (!active) return; active = false; ring.classList.remove('is-interactive'); };

  function actionAt(event) {
    for (const node of event.composedPath()) {
      if (!(node instanceof Element)) continue;
      if (node.matches(':disabled,[aria-disabled="true"],input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]),textarea,[contenteditable="true"]')) return null;
      if (node.matches(actions)) return node;
      if (node.matches('label') && node.control && !node.control.disabled && node.control.matches('[type="checkbox"],[type="radio"]')) return node.control;
    }
    return null;
  }

  function move(event) {
    if (!media.matches || event.pointerType === 'touch') { hide(); return; }
    point = { x: event.clientX, y: event.clientY };

    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      ring.style.transform = `translate3d(${point.x - 19}px, ${point.y - 19}px, 0)`;
    });
  }

  document.addEventListener('pointerover', event => {
    if (!media.matches || event.pointerType === 'touch') return;
    const action = actionAt(event);
    styleShadowAction(action);
    const next = !!action;
    if (next === active) return;
    active = next;
    ring.classList.toggle('is-interactive', active);
  }, { passive: true, signal });
  document.addEventListener('pointermove', move, { passive: true, signal });
  document.addEventListener('pointerout', event => { if (!event.relatedTarget) hide(); }, { passive: true, signal });
  document.addEventListener('pointerdown', () => ring.classList.add('is-pressed'), { passive: true, signal });
  document.addEventListener('pointerup', () => ring.classList.remove('is-pressed'), { passive: true, signal });
  document.addEventListener('pointercancel', () => { ring.classList.remove('is-pressed'); hide(); }, { passive: true, signal });

  document.addEventListener('visibilitychange', hide, { signal });
  window.addEventListener('blur', hide, { signal });
  media.addEventListener('change', hide, { signal });
  signal.addEventListener('abort', () => {
    if (frame) cancelAnimationFrame(frame);
    ring.remove();
    document.documentElement.removeAttribute('data-atlas-cursor-ring-ready');
    delete window.__atlasCursorRing;
  }, { once: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atlas-preview-polish"] && !Shopify.designMode) return;
  try {
    (() => {
  const bind = (selector, attribute, className, value) => {
    const target = document.querySelector(selector);
    if (!target) return;
    const update = () => document.body.classList.toggle(className, value === undefined ? target.hasAttribute(attribute) : target.getAttribute(attribute) === value);
    update();
    new MutationObserver(update).observe(target, { attributes: true, attributeFilter: [attribute] });
  };
  bind('header-drawer > details', 'open', 'atlas-menu-open');
  bind('shopify-chat', 'open', 'atlas-chat-open');
  bind('.sticky-add-to-cart__bar', 'data-stuck', 'atlas-cart-stuck', 'true');
})();
  } catch(e) { console.error(e); }
})();

})();
